<script lang="ts" setup>
import CheckIcon from '~/assets/icons/statuses/success.svg'
import QuestionIcon from '~/assets/icons/statuses/question.svg'
import ArrowIcon from '~/assets/icons/arrows/16/arrow-right-black.svg?component'
import AppButton from '~/components/ui/buttons/AppButton.vue'
import Tooltip from '~/components/ui/tooltips/Tooltip.vue'
import MobileModal from '~/components/ui/modals/MobileModal.vue'
import { useMonitorSize } from '~/composables/monitor-size'
import getFormatTitle from '~/composables/product-title-formatter'
import type { IBrandsTableRow } from '~/shared/interfaces/search/brands'
import type { IBrandsMeiliSearchTableRow } from '~/shared/interfaces/search/meiliSearch'
import type { IMonitorSize } from '~/shared/interfaces/composables'

defineProps<{
  searchResults: IBrandsTableRow[] | IBrandsMeiliSearchTableRow[]
  offersCell: boolean
}>()

let sizes: IMonitorSize | null = useMonitorSize()

const isTooltipModal = ref(false)

const questionTooltipText = `
  Предварительная информация по предложениям недоступна. <br>
  Перейдите к следующему этапу поиска, чтобы уточнить данные
`

function toggleModal(state: boolean) {
  isTooltipModal.value = state
}
async function goToSearchByProduct({
  article,
  brand,
}: IBrandsTableRow | IBrandsMeiliSearchTableRow) {
  await navigateTo(`/search/${article}/${brand.name}`)
}
</script>

<template>
  <div class="search__table search__table_brands">
    <div
      v-for="brandRow in searchResults"
      :key="brandRow.brand + '__brands-table'"
      @click="sizes && !sizes.isMobile && goToSearchByProduct(brandRow)"
      class="search__table-row"
    >
      <div class="search__table-cell search__table-cell_brand brand-name">
        {{ brandRow.brand.name }}
      </div>
      <div class="search__table-cell search__table-cell_article">
        {{ brandRow.article }}
      </div>
      <div class="search__table-cell search__table-cell_title">
        {{ brandRow.title ? getFormatTitle(brandRow.title) : '—' }}
      </div>
      <div
        class="search__table-cell search__table-cell_offers"
        :class="[
          (brandRow.isOriginalAvailable || brandRow.isAnalogsAvailable) &&
            'active',
          !brandRow.isOriginalAvailable &&
            !brandRow.isAnalogsAvailable &&
            'disabled',
        ]"
        v-show="offersCell"
      >
        <span>Предложения</span>
        <div
          class="tooltip-container"
          v-if="brandRow.isOriginalAvailable || brandRow.isAnalogsAvailable"
        >
          <CheckIcon />
        </div>
        <div class="tooltip-container" v-else>
          <QuestionIcon @click="sizes && sizes.isMobile && toggleModal(true)" />
          <Tooltip :text="questionTooltipText" />
        </div>
      </div>
      <div class="search__table-cell search__table-cell_btn">
        <AppButton
          type="neutral"
          text="Цены и наличие"
          size="s"
          :icon="ArrowIcon"
          direction="row-reverse"
          @click="sizes && sizes.isMobile && goToSearchByProduct(brandRow)"
        />
      </div>
    </div>
    <Teleport to="body">
      <MobileModal
        v-if="sizes && sizes.isMobile"
        :modal-is-open="isTooltipModal"
        @close-modal="toggleModal(false)"
      >
        <p>
          Предварительная информация по&nbsp;предложениям недоступна. Перейдите
          к&nbsp;следующему этапу поиска, чтобы уточнить данные
        </p>
      </MobileModal>
    </Teleport>
  </div>
</template>

<style lang="scss" scoped></style>
